import React from 'react';
import PropTypes from 'prop-types';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';


import withStyles from '@mui/styles/withStyles';
import { red, lime, indigo } from '@mui/material/colors';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    //ChartDataLabels
    ArcElement
);

const styles = {
    chart: {
        paddingLeft: '15%',
        paddingRight: '15%'
    }
}

class TypesIndicateursNbOuvertesGraph extends React.Component {

    getData = () => {
        var propsData = [...this.props.indicateurs];

        var labels = [];
        var data = [];

        for (var i = 0; i < propsData.length; i++) {
            labels.push(propsData[i].libelle);
            data.push(propsData[i].nombre);
        }

        return {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: [
                    red[500],
                    lime[500],
                    indigo[500]
                ],
                hoverBackgroundColor: [
                    red[500],
                    lime[500],
                    indigo[500]
                ]
            }]
        };
    }

    getOptions = () => ({
        circumference: 180,
        rotation: -90,
        cutout: '60%',
        maintainAspectRatio: false,
        layout: {
            padding: 10
        },
        plugins: {
            title: {
                display: true,
                text: 'Dossier après-vente ouvert par type',
                position: 'bottom',
                font: {
                    family: 'Roboto',
                    weight: '500'
                }
            },
            legend: {
                position: 'bottom',
                font: {
                    family: 'Roboto',
                    weight: 'normal'
                }
            },
            tooltip: {
                enabled: false
            },
            datalabels: {
                anchor: 'end',
                backgroundColor: function (context) {
                    return context.dataset.backgroundColor;
                },
                borderColor: 'white',
                borderRadius: 25,
                borderWidth: 2,
                color: 'white',
                font: {
                    weight: 'bold'
                },
                textAlign: 'center'
            }
        }
    });

    render() {

        const data = this.getData();
        //console.log(data);

        const options = this.getOptions();
        //console.log(options);

        return (
            <div className={this.props.classes.chart}>
                <Doughnut data={data} options={options} width={640} height={320}/>
            </div>
        )
    }
}

TypesIndicateursNbOuvertesGraph.propTypes = {
    classes: PropTypes.object.isRequired,
    indicateurs: PropTypes.array.isRequired
};

export default withStyles(styles)(TypesIndicateursNbOuvertesGraph);